import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VipAdvertItem from '../../main/items/vip_advert_item';
import rightArrowIcon from '../../../assets/icons/right_arrow.svg';

const AuthorAdsResponsive = ({ ads = [], user }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 4;

    const totalPages = Math.ceil(ads.length / itemsPerPage);

    const currentAds = ads.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const handleNext = () => {
        if (currentPage < totalPages - 1) setCurrentPage(prev => prev + 1);
    };

    const handlePrevious = () => {
        if (currentPage > 0) setCurrentPage(prev => prev - 1);
    };

    const handleNavigate = () => {
        if (user?.id) {
            navigate("/company", { state: { user } });
        }
    };

    return (
        <div className="mt-[120px] md:mt-[50px] mb-[85px] md:mb-0 w-full flex flex-col author_ads_container px-5">

            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full mb-5 gap-4">
                <h2
                    className="text-[36px] md:text-xl font-bold text-[#222222] m-0 cursor-pointer"
                    onClick={handleNavigate}
                >
                Басқа жарнамалар
                </h2>

                {/* Desktop navigation */}
                <div className="flex gap-2 md:flex hidden">
                    <button
                        className="bg-white border border-[#D4D4D4] rounded-full h-[44px] w-[44px] flex justify-center items-center hover:bg-gray-100 hover:border-[#147F26] transition-colors disabled:bg-[#F5F5F5] disabled:border-[#E0E0E0] disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#147F26]/40"
                        onClick={handlePrevious}
                        disabled={currentPage === 0}
                    >
                        <img src={rightArrowIcon} alt="Left" className="rotate-180" />
                    </button>

                    <button
                        className="bg-white border border-[#D4D4D4] rounded-full h-[44px] w-[44px] flex justify-center items-center hover:bg-gray-100 hover:border-[#147F26] transition-colors disabled:bg-[#F5F5F5] disabled:border-[#E0E0E0] disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#147F26]/40"
                        onClick={handleNext}
                        disabled={currentPage === totalPages - 1}
                    >
                        <img src={rightArrowIcon} alt="Right" />
                    </button>
                </div>
            </div>

            {/* Ads Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-5 w-full auto-rows-fr md:flex-row md:flex-wrap md:justify-start md:items-center">
                {currentAds.length > 0 ? (
                    currentAds.map(ad => {
                        const imageUrl = ad.image_url || ad.main_image_url || '';

                        return (
                            <VipAdvertItem
                                key={ad.id}
                                id={ad.id}
                                imagePath={imageUrl}
                                name={ad.title}
                                price={ad.price}
                                price_type={ad.price_type}
                                is_negotiable={ad.is_negotiable || ad.negotiable}
                                barter={ad.barter}
                                location={
                                    ad.location || {
                                        province: ad.city || '',
                                        locality: ad.city || ''
                                    }
                                }
                                date={ad.created_at || ad.date}
                                is_favorite={ad.is_favorite || false}
                            />
                        );
                    })
                ) : (
                    <p className="col-span-full text-center text-gray-500 mt-4">
                        {/* Объявлений нет. */}
                    </p>
                )}
            </div>

            {/* Mobile navigation */}
            {totalPages > 1 && (
                <div className="flex md:hidden items-center justify-center w-full mt-6 gap-4">
                    <button
                        className="border-none cursor-pointer rounded-full h-10 w-10 flex justify-center items-center transition-colors disabled:bg-[#EDEDED] disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={handlePrevious}
                        disabled={currentPage === 0}
                    >
                        <img src={rightArrowIcon} alt="Left" className="rotate-180 w-4 h-4" />
                    </button>

                    <span className="text-sm font-medium text-[#222222]">
                        {currentPage + 1} / {totalPages}
                    </span>

                    <button
                        className="border-none cursor-pointer rounded-full h-10 w-10 flex justify-center items-center transition-colors disabled:bg-[#EDEDED] disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={handleNext}
                        disabled={currentPage === totalPages - 1}
                    >
                        <img src={rightArrowIcon} alt="Right" className="w-4 h-4" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default AuthorAdsResponsive;